// extracted by mini-css-extract-plugin
module.exports = {"form":"NoteForm_form__2Xtvb","btnWrapper":"NoteForm_btnWrapper__MmVdG","heightSpacer":"NoteForm_heightSpacer__1x8Dk","spacer":"NoteForm_spacer__3kCHZ"};